import React, {ReactElement} from 'react';

import GroupsIcon from '@mui/icons-material/Groups';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AdbIcon from '@mui/icons-material/Adb';
import ArticleIcon from '@mui/icons-material/Article';
import FlightIcon from '@mui/icons-material/Flight';
import FlightLand from '@mui/icons-material/FlightLand';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import BarChartIcon from '@mui/icons-material/BarChart';
import HistoryIcon from '@mui/icons-material/History';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import TaskIcon from '@mui/icons-material/Task';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import {ResourceType} from '../@types/resource-type';
import { AdminPanelSettings, SummarizeOutlined, FollowTheSigns } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';

export function resourceIcon(type: ResourceType, subType?: ResourceType): ReactElement {
    switch (type) {
        case ResourceType.USERS:
            return <AdminPanelSettings fontSize="small" />;
        case ResourceType.GROUPS:
            return <GroupsIcon fontSize="small" />;
        case ResourceType.GROUP_ROLE_PERMISSIONS:
            return <FollowTheSigns fontSize="small" />;
        case ResourceType.EVENT_SEQUENCES:
            return subType === undefined ?
                <Avatar sx={{ width: 24, height: 24 }}>
                    <Typography variant='caption'>ES</Typography>
                </Avatar> : <Avatar sx={{ width: 24, height: 24, bgcolor: deepPurple[500] }}>
                    <Typography variant='caption'>C</Typography>
                </Avatar>;
        case ResourceType.EVENT_SEQUENCE_TREES:
            return <FlightLand fontSize="small" />;
        case ResourceType.EVENT_SEQUENCE_HISTORY:
        case ResourceType.EVENT_SEQUENCE_HISTORY_TREES:
            return <HistoryIcon fontSize="small" />;
        case ResourceType.EVENT_SEQUENCE_SENSITIVIY_ANALYSIS:
            return <ArchitectureIcon fontSize="small" />;
        case ResourceType.EVENT_SEQUENCE_UNCERTAINTY_ANALYSIS:
            return <BarChartIcon fontSize="small" />;
        case ResourceType.UNKNOWN:
        case ResourceType.SAFETY_MODELS:
            return <AccountTreeIcon  fontSize = "small"/>;
        case ResourceType.OCCURRENCE_REPORTS:
            return <ArticleIcon  fontSize = "small"/>;
        case ResourceType.OCCURRENCE_TYPES:
            return <SummarizeOutlined fontSize = "small"/>;
        case ResourceType.PERFORMANCE_SHAPING_FACTORS:
            return <PrecisionManufacturingIcon fontSize = "small"/>;
        case ResourceType.TRAFFIC_MODELS:
            return <FlightIcon  fontSize = "small"/>;
        case ResourceType.OPERATIONAL_CHANGES:
            return <NetworkCheckIcon  fontSize = "small"/>;
        case ResourceType.WORKSHOPS:
            return <TaskIcon  fontSize = "small"/>;
        case ResourceType.RISK_FORECASTS:
            return <TrendingDownIcon  fontSize = "small"/>;
        default:
            return <AdbIcon  fontSize = "small"/>;
    }
}
